import { FormEvent, useState } from 'react';
import * as _ from 'lodash';
import { IDonor, IMatchRunSwap } from '@nkr/models/index';
import { ChainStarterListLoopsTableWrapper } from './styles';
import { Glyphicon } from 'react-bootstrap';

interface IProps {
    swaps: IMatchRunSwap[],
    deepestChainDepth: number,
    donors: IDonor[],
    selectedChainStarters: number[],
    onSelectedChainStartersChanged: (list: number[]) => void
}

const ChainStarterListLoops = (props: IProps) => {
    const handleSelectChainStarer = (e: FormEvent<HTMLInputElement>) => {
        let selectedChainStarters = _.cloneDeep(props.selectedChainStarters);

        let id = parseInt(e.currentTarget.value);

        if (selectedChainStarters.indexOf(id) >= 0) {
            selectedChainStarters = selectedChainStarters.filter(x => x != id);
        } else {
            selectedChainStarters.push(id);
        }

        props.onSelectedChainStartersChanged(selectedChainStarters);
    };

    const handleSelectAllChainStarters = () => {
        let selectedChainStarters = props.swaps.map(x => x.chainStart);

        props.onSelectedChainStartersChanged(props.selectedChainStarters.length > 0 ? [] : selectedChainStarters);
    };

    let chainStarters = _.uniq(props.swaps.map(x => x.chainStart));

    let list = chainStarters.map(chainStarter => {
        let swaps = props.swaps.filter(x => x.chainStart == chainStarter)
        let donor = props.donors.find(x => x.id == chainStarter);

        let uniqueDepths = _.uniq(swaps.map(x => x.depth)).sort();;

        return {
            center: donor.center.alias,
            id: donor.id,
            alias: donor.alias,
            depths: uniqueDepths.map(depth => {
                return {
                    depth,
                    depthCount: swaps.filter(x => x.depth == depth).length
                }
            })
        };
    });

    let sortedList = _.sortBy(list, x => x.alias);

    return (
        <>
            <ChainStarterListLoopsTableWrapper condensed bordered>
                <thead>
                    <tr>
                        <th><Glyphicon glyph='check' onClick={handleSelectAllChainStarters} /></th>
                        <th>ChainStart Center</th>
                        <th>ChainStart Alias</th>
                        <th>Depth</th>
                        <th>Swap Count</th>
                    </tr>
                </thead>
                {sortedList.map((chainStarter, index) =>
                    <tbody key={'swap-' + index} style={{ backgroundColor: index % 2 == 0 ? '#f9f9f9' : null }}>
                        <tr>
                            <td><input id={'chain-starter-' + index} value={chainStarter.id} type='checkbox' checked={props.selectedChainStarters.indexOf(chainStarter.id) >= 0} onClick={handleSelectChainStarer} /></td>
                            <td>{chainStarter.center}</td>
                            <td>{chainStarter.alias}</td>
                            <td>{chainStarter.depths[0].depth}</td>
                            <td>{chainStarter.depths[0].depthCount}</td>
                        </tr>
                        {chainStarter.depths.map((item, depthIndex) => {
                            if (depthIndex > 0) {
                                return (
                                    <tr key={'depth-' + depthIndex}>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{item.depth}</td>
                                        <td>{item.depthCount}</td>
                                    </tr>
                                );
                            }
                        })}
                    </tbody>
                )}
            </ChainStarterListLoopsTableWrapper>
        </>
    );
}

export default ChainStarterListLoops;